export const BrandMark = ({ className }) => (
  <div className={['grid place-items-center', className].filter(Boolean).join(' ')} aria-hidden="true">
    <div className="relative h-10 w-10">
      <div className="absolute inset-0 rounded-xl bg-primary/20 blur-xl" />
      <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-primary/70 via-secondary/30 to-accent/30" />
      <div className="absolute inset-[2px] rounded-[10px] bg-base-100" />
      <div className="absolute inset-[6px] rounded-lg bg-gradient-to-br from-base-200 via-base-100 to-base-300" />
      <img src="/img/logo.jpeg" alt="" className="absolute inset-[6px] h-[calc(100%-12px)] w-[calc(100%-12px)] rounded-lg object-cover" />
    </div>
  </div>
);
